<template>
  <div class="Rank">
    <div class="note" v-if="procedure == 1">
      <p>每日12点与20点更新积分和排行榜，如有疑问请联系微信客服</p>
    </div>
    <div class="note" v-if="procedure == 2">
      <p>初赛结束，排行榜积分停止更新。如有疑问请联系微信客服</p>
    </div>
    <div class="group">
      <div class="grp fs20" :class="{focus: fcg==g.key }" v-for="g in groups" @click="focus(g.key)">{{g.text}}</div>
    </div>
    <my_table :infos="info" :titles="titles" :isRank="true" :rankLength="-1" ></my_table>
  </div>
</template>

<script>
 import MyTable from '@/components/Table.vue'
 import QRCode from '@/assets/image/rank/aiyouth-qr.png'
 import MyImage from '@/components/Image.vue'

 export default {
   name: 'Rank',
   props: ['procedure'],
   computed: {
     showExtraArea() {
       return this.fcg =='n' || this.fcg == 'sz';
     },
     user() {
       return this.$store.state.auth.user
     },
     groups() {
       return this.$store.state.enroll.groups
     },
     titles() {
       return this.$store.state.score.rank.school_title
     },
     game_slug() {
       return this.$store.state.game_slug
     },
     extraTitles() {
       return ['排名', '昵称', '逃出地牢积分', '省市']
     }, 
     infos () {
       return this.$store.state.score.rank.infos
     },
     indexOfExtra() {
       return {
         'n':'NingXia',
         'sz': "SuZhou"
       }
     },
     remapExtra() {
       return {
         'NingXia': '宁夏',
         'SuZhou': '苏州'
       }
     },
     indexOfGroup() {
       return {
         's': 1,
         'm': 2,
         'l': 3
       }
     },
     qrcode() {
       return QRCode
     }
   },
   data() {
     return {
       fcg: 's',
       info: [],
       extraInfo: [],
     }
   },
   methods: {
     fetchData () {
         let round = this.game_slug.slice(0, -1) + '1';
         let group =  this.indexOfGroup[this.fcg];
         let uri = '/api/rank/school?round='+round+'&group='+group;
         this.$http.get(uri)
             .then(res => {
               this.info = res.data.map(d=>
                 {return [d.rank, d.name, d.score, d.ozaria, d.total]})
             })
     },
     focus(k) {
       this.fcg = k
       this.fetchData()
     },
     jump(i) {
       if(i == 0)
         window.open('https://mp.weixin.qq.com/s/SzVnoGDSahvE1dF95vfqkg', '_blank');
       else
         window.open('https://mp.weixin.qq.com/s/wF4I_PQmJZmhVroE8VaK9Q', '_blank')
     }
   },
   mounted() {
     this.fetchData()
   },
   components: {
     my_table: MyTable,
     my_image: MyImage
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Rank{
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   margin-top: 5vw;
   margin-bottom: 3.4vw;
 }
 .group{
   display: flex;
   align-items:center;
   justify-content: space-around;
   width: 50vw;
   border-bottom: 1px dashed black;
   margin-bottom: 1.5625vw;
 }
 .grp{
   line-height: 2.5vw;
 }
 .focus{
   border-bottom: 1px solid black;
   color: #4411FF;
 }
 .note{
   text-align: center;
   margin-bottom: 3vw;
   color: black;
 }
</style>
